var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OverlayContainer } from '@angular/cdk/overlay';
var EditorOverlayContainer = /** @class */ (function (_super) {
    __extends(EditorOverlayContainer, _super);
    function EditorOverlayContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditorOverlayContainer.prototype._createContainer = function () {
        var container = document.createElement('div');
        container.classList.add('editor-overlay-container', 'cdk-overlay-container');
        document.querySelector('image-editor').appendChild(container);
        this._containerElement = container;
    };
    return EditorOverlayContainer;
}(OverlayContainer));
export { EditorOverlayContainer };
